import type {NextPage} from 'next';

import Auth from 'components/App/Auth';
import Page from 'components/App/Page';

const SignUp: NextPage = () => {
  return (
    <Page noAuth title="pages.login.title" className="overflow-hidden">
      <div className="m-auto mx-auto">
        <div className="relative flex items-center justify-center">
          <div className="absolute w-[700px] h-[700px] sm:bottom-[-80px] md:bottom-[-80px] lg:bottom-[-80px] xl:bottom-[-80px] 2xl:bottom-[-80px] bottom-[-260px] bg-[#2B53E1] rounded-full" />
          <div className="relative z-10 py-4 noramp-bg rounded-2xl">
            <Auth title="NoRamp Sign Up" />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default SignUp;
